import { ReactNode, type FC } from 'react'

import { DraggableRectangle } from './DraggableRectangle'
import { ShapeProps, ShapeType } from '@kouto/types'
import { DraggableCircle } from './DraggableCircle'
import { DraggableTable } from './DraggableTable'

export type MapShapeProps = ShapeProps & {
  canDragOutsideMap: boolean
  currentMapScale: number
  mapSize: { width: number; height: number }
  className?: string
  children?: ReactNode
}

export const RawShape: FC<MapShapeProps> = props => {
  switch (props.type) {
    case ShapeType.RECTANGLE:
      return <DraggableRectangle {...props} />
    case ShapeType.CIRCLE:
      return <DraggableCircle {...props} />
    case ShapeType.TABLE:
      return <DraggableTable {...props} />
    default:
      return null
  }
}

export const Shape: FC<MapShapeProps> = props => {
  return <RawShape {...props} className={'customMapShape'} />
}
